import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss'],
  animations: [slide]
})
export class CompanyListComponent implements OnInit {
  companies:  FirebaseListObservable<any[]>;
  selectedCompany: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  companyType: string;

  constructor(
    private router: Router,
    private dbService: DBService
  ) { }

  ngOnInit() {
    switch(this.router.url) {
      case '/companies':
        this.companies = this.dbService.getCompanies();
        this.companyType = 'member';
        break;

      case '/vendors':
        this.companyType = 'vendor';
        this.companies = this.dbService.getVendors();
        break;
    }
  }

  onAddCompanyClicked() {
    this.selectedCompany = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }


  showCompany(company: any) {
    if (this.companyType == 'vendor') {
      this.router.navigate([`/vendors/${company.$key}`]);
    } else {
      this.router.navigate([`/companies/${company.$key}`]);
    }
  }

  getUsers(company) {
  }

  /*userLevelType(member) {
    switch(member.userLevel) {
      case 0:
        return 'Vendor';
      case 1:
        return 'Member';
      case 2:
        return 'Owner';
    }
  }*/

  onEditClicked(company, event) {
    event.stopPropagation();
    this.selectedCompany = company;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(company, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedCompany = company;
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteCompany(this.selectedCompany.$key);
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  onHideFormModal() {
    this.showModalBg = false;
    this.showFormModal = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/companies/company-list/company-list.component.ts